<script setup lang="ts">
import type { LoyaltyMerchantFormConfigSection } from '../types/global'
import CardTitle from './CardTitle.vue'
import ConfigField from './ConfigField.vue'

defineProps<{
  configs: LoyaltyMerchantFormConfigSection[]
}>()
</script>

<template>
  <div v-for="config in configs" :key="config.title" class="rounded-md border bg-white">
    <div class="p-2 sm:border-b sm:border-border md:p-6">
      <CardTitle :title="config.title" />
    </div>
    <div class="flex flex-col gap-8 px-2 py-8 md:px-8">
      <div class="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div v-for="(item, index) in config.items" :key="item.type" class="my-2">
          <ConfigField :item="item" :index="index" />
        </div>
      </div>
      <slot name="content" />
    </div>
  </div>
</template>
